import React, { useMemo } from "react";
import { GoogleMap, Marker, OverlayView, Polyline } from "@react-google-maps/api";

import DetailDialog from "./DetailDialog";
import MAP_STYLE from "../../home/components/mapStyle";
import { formatKm, haversineKm } from "../deliverability";

const CONTAINER_STYLE = { width: "100%", height: "280px" };

const MAP_OPTIONS = {
  styles: MAP_STYLE,
  disableDefaultUI: true,
  zoomControl: false,
  clickableIcons: false,
  gestureHandling: "cooperative",
};

const LINE_OPTIONS = {
  strokeColor: "#AE6F28",
  strokeOpacity: 0,
  icons: [
    {
      icon: { path: "M 0,-1 0,1", strokeOpacity: 0.7, scale: 3 },
      offset: "0",
      repeat: "12px",
    },
  ],
};

const LocationSheet = ({ open, supplierName, supplier, origin, mapsReady, onClose }) => {
  const distanceKm = useMemo(
    () => haversineKm(origin, supplier),
    [origin, supplier]
  );

  return (
    <DetailDialog
      open={open}
      title={supplierName}
      variant="sheet"
      className="sy-location-sheet"
      onClose={onClose}
    >
      {supplier && mapsReady ? (
        <GoogleMap
          center={{ lat: supplier.latitude, lng: supplier.longitude }}
          zoom={13}
          options={MAP_OPTIONS}
          mapContainerStyle={CONTAINER_STYLE}
        >
          <Marker
            position={{ lat: supplier.latitude, lng: supplier.longitude }}
            title={supplierName}
          />

          {origin && (
            <>
              <OverlayView
                position={{ lat: origin.latitude, lng: origin.longitude }}
                mapPaneName={OverlayView.OVERLAY_LAYER}
                getPixelPositionOffset={(width, height) => ({
                  x: -(width / 2),
                  y: -(height / 2),
                })}
              >
                <span className="home-map-user-dot" />
              </OverlayView>

              <Polyline
                path={[
                  { lat: origin.latitude, lng: origin.longitude },
                  { lat: supplier.latitude, lng: supplier.longitude },
                ]}
                options={LINE_OPTIONS}
              />
            </>
          )}
        </GoogleMap>
      ) : (
        <p className="sy-muted">This supplier has not shared a location yet.</p>
      )}

      {Number.isFinite(distanceKm) && (
        <p className="sy-location-distance">{formatKm(distanceKm)} from your location</p>
      )}
    </DetailDialog>
  );
};

export default LocationSheet;
